export default __webpack_public_path__ + "static/media/ticket-4.479c2196.png";